import React from "react";
import "./Main.css";
import StoryContent from "./StoryContent";
const StorySection = () => {
  return (
    <div className="about__story-section">
      <div className="uigrid about__story-section-top">
        <header className=" uigrid-6 about__story-section-header">
          <h3>About Awa Digital</h3>
          <p>
            We develop complex systems in diverse markets, transforming client
            specifications and requirements into scalable software.
          </p>
          <p>
            Registered in the UK (Companies House 16042028) and Nigeria (RC
            3333358) we run a diverse portfolio of products in the UK and
            Nigeria.
          </p>
        </header>
      </div>
      {/* <div className="uigrid">
        <StoryContent />
      </div> */}
    </div>
  );
};

export default StorySection;
